// common
export const GET_IS_SITE_PUBLISHED = "GET_IS_SITE_PUBLISHED";
export const IS_USER_HAS_PREMIUM = "IS_USER_HAS_PREMIUM ";
export const GET_WIX_SITE_INFO = "GET_WIX_SITE_INFO";
export const GET_WIX_SITE_INFO_ERROR = "GET_WIX_SITE_INFO_ERROR";
export const GET_DOMAIN_CONNECT_STATUS = "GET_DOMAIN_CONNECT_STATUS";
export const RESET_STATE = "RESET_STATE";
export const IS_DOMAIN_CONNECTED = "IS_DOMAIN_CONNECTED";
export const GET_COMP_ID = "GET_COMP_ID";
export const GET_INSTANCE_ID = "GET_INSTANCE_ID";
export const SET_DATA_PUBLIC = "SET_DATA_PUBLIC";

// settings
export const LOAD_SETTINGS = "LOAD_SETTINGS";

// userAccountWizard
export const LOAD_USER_ACCOUNT_WIZARD = "LOAD_USER_ACCOUNT_WIZARD";
export const IS_USER_ACCOUNT_EXIST = "IS_USER_ACCOUNT_EXIST";
export const IS_GET_STARTED_BTN_DISABLED = "IS_GET_STARTED_BTN_DISABLED";
export const IS_GET_STARTED_BTN_SHOW = "IS_GET_STARTED_BTN_SHOW";
export const IS_GO_TO_ADSENSE_BTN_SHOW = "IS_GO_TO_ADSENSE_BTN_SHOW";
export const IS_PASTED_CODE_REQUEST = "IS_PASTED_CODE_REQUEST";
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_IMAGE = "SET_IMAGE";
export const SET_LABEL = "SET_LABEL";
export const SET_DESC = "SET_DESC";
export const SET_LINKS = "SET_LINKS";
export const SET_LIST = "SET_LIST";
export const CLICK_GET_STARTED_BTN = "CLICK_GET_STARTED_BTN";
export const CLICK_GO_TO_ADSENSE_BTN = "CLICK_GO_TO_ADSENSE_BTN";
export const IS_DIVIDER_ACTIVE = "IS_DIVIDER_ACTIVE";
export const SET_IS_GD_UNIT_ADDED_SCRIPT = "SET_IS_GD_UNIT_ADDED_SCRIPT";
export const SAVED_GD_UNIT_ADDED_SCRIPT = "SAVED_GD_UNIT_ADDED_SCRIPT";
export const IS_GD_SENSE_APP_ACTIVATED = "IS_GD_SENSE_APP_ACTIVATED";

// userAccountWizard - wizardNav
export const IS_WIZARD_NAV_ACTIVE = "IS_WIZARD_NAV_ACTIVE";
export const GET_WIZARD_NAV_LENGTH = "SET_WIZARD_NAV_LENGTH";
export const CLICK_WIZARD_NAV_BACK_BTN = "CLICK_WIZARD_NAV_BACK_BTN";
export const CLICK_WIZARD_NAV_NEXT_BTN = "CLICK_WIZARD_NAV_NEXT_BTN";
export const CLICK_WIZARD_NAV_DONE_BTN = "CLICK_WIZARD_NAV_DONE_BTN";
export const INCREASE_WIZARD_NAV_POSITION = "INCREASE_WIZARD_NAV_POSITION";
export const DECREASE_WIZARD_NAV_POSITION = "DECREASE_WIZARD_NAV_POSITION";
export const IS_NEXT_BTN_ACTIVE = "IS_NEXT_BTN_ACTIVE";
export const IS_MY_SITE_HAS_BEEN_ADDED = "IS_MY_SITE_HAS_BEEN_ADDED";
export const SET_WIZARD_NAV_LENGTH = "SET_WIZARD_NAV_LENGTH";
export const VALIDATION_GD_UNIT_CODE = "VALIDATION_GD_UNIT_CODE";

// noDomainWizard
export const GET_IS_DOMAIN_CONNECTED = "GET_IS_DOMAIN_CONNECTED";
export const SET_NO_DOMAIN_MESSAGE = "SET_NO_DOMAIN_MESSAGE";
export const CLICK_GET_STARTED_BTN_NO_DOMAIN =
  "CLICK_GET_STARTED_BTN_NO_DOMAIN";
export const IS_GET_STARTED_BTN_NO_DOMAIN_DISABLED =
  "IS_GET_STARTED_BTN_NO_DOMAIN_DISABLED";
export const IS_DOMAIN_CONNECTION_CHECKED = "IS_DOMAIN_CONNECTION_CHECKED";

//adUnitControlPanel
export const GD_UNIT_MAIN_TAB_SELECTED = "GD_UNIT_MAIN_TAB_SELECTED";
export const GD_UNIT_GD_CODE_TAB_SELECTED = "GD_UNIT_GD_CODE_TAB_SELECTED";
export const GD_UNIT_SUPPORT_TAB_SELECTED = "GD_UNIT_SUPPORT_TAB_SELECTED";
export const VALIDATE_GD_UNIT_CODE = "VALIDATE_GD_UNIT_CODE";
export const IS_GD_UNIT_CODE_VALID = "IS_GD_UNIT_CODE_VALID";
export const GD_UNIT_STATE = "GD_UNIT_STATE";
export const GD_UNIT_INIT_STATE = "GD_UNIT_INIT_STATE";
export const GET_GD_UNIT_STATE = "GET_GD_UNIT_STATE";
export const SET_DIVIDER_LABEL = "SET_DIVIDER_LABEL";
export const GD_UNIT_CODE_VALIDATION_STATUS = "AD_UNIT_CODE_VALIDATION_STATUS";
export const SAVE_GD_UNIT_CODE_TO_DB = "SAVE_GD_UNIT_CODE_TO_DB";

//widgetPage
export const SET_IS_DISPLAY_TITLE = "SET_IS_DISPLAY_TITLE";
export const SET_USER_NAME = "SET_USER_NAME";
export const SET_CAN_EDIT = "SET_CAN_EDIT";
export const SET_IS_NEW_FILE = "SET_IS_NEW_FILE";
export const SET_IS_NEW_FILE_MOBILE = "SET_IS_NEW_FILE_MOBILE";



//data public
export const COMPONENT = "COMPONENT";
export const INSTANCE_ID = "instanceId";
export const COMPONENT_ID = "componentId";
export const CREATED_AT = "createdAt";
export const TOKEN = "token";
export const SIGNED_AT = "signedAt";
export const ACTIVE_FILE_ID = "activeFileId";
export const DELETED_AT = "deletedAt";

//searchDriveApi
export const UPDATE_NAVIGATION_LIST = "UPDATE_NAVIGATION_LIST";
export const UPDATE_NAVIGATION_LIST_SEARCH = "UPDATE_NAVIGATION_LIST_SEARCH";


//userConnect
export const SET_LAYOUT_FILE = "SET_LAYOUT_FILE";
export const SET_LAYOUT_FOLDER = "SET_LAYOUT_FOLDER";
export const SET_DISPALY_LAST_MODIFIED = "SET_DISPALY_LAST_MODIFIED";
export const SET_DYSPLAY_OWNER = "SET_DYSPLAY_OWNER";
export const SET_SORT_SEFAULT = "SET_SORT_SEFAULT";
export const UPDATE_ERROR_CONNECT = "UPDATE_ERROR_CONNECT";


////////////widget- size to display
export const LARGE = "large";
export const MEDIUM = "medium";
export const SMALL = "small";
export const SIGNAL_FILE = "signal-file";

//////////layout
export const THUMBNAIL = "thumbnail";
export const LIST = "list";



// WEBPACK FOOTER //
// ./src/constants/index.js